import React from 'react';

import './AdvertisementBanner.scss';

export default function AdvertisementBanner(props) {
  return (
    <section id="advertisementBanner">
      <h6>Partner</h6>

      <a target="_blank" href={props.link} rel="noopener noreferrer">
        <img alt="advertisement-image" src={props.imageURL} />
      </a>
    </section>
  );
}
